// extracted by mini-css-extract-plugin
export default {"cls1":"zVpHkXJNFUJvIRE6Z3Qp","cls2":"I7x5gafkYb3iTB88Xpnq zVpHkXJNFUJvIRE6Z3Qp"};